import { FunctionComponent, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { StoryCardPollContent } from '../../../services';
import { FeedCardProps } from '../../../shared';
import { FeedCardPreviewContent } from '../FeedCardPreviewContent';
import { FeedCardPreviewWrapper } from '../FeedCardPreviewWrapper';

export const FeedCardPreviewPoll: FunctionComponent<FeedCardProps> = memo(({ card }) => {
  const { t } = useTranslation();

  const { content } = card;

  const { headline, text } = content as StoryCardPollContent;

  return (
    <FeedCardPreviewWrapper card={card}>
      <FeedCardPreviewContent
        source={t('common.vote-now')}
        title={headline}
        text={text}
      ></FeedCardPreviewContent>
    </FeedCardPreviewWrapper>
  );
});
